import CTASection from '../components/CTASection/CTASection';
import { howItWorksSteps } from '../data/howItWorks';
import { stockAssets } from '../config/stockAssets';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './HowItWorksPage.module.css';

function HowItWorksPage() {
  usePageTitle('How It Works');

  return (
    <>
      <section className={styles.hero}>
        <div className={`container ${styles.heroGrid}`}>
          <div>
            <span className="sectionLabel">How it works</span>
            <h1 className={styles.title}>From fan scan to seat delivery in four steps</h1>
            <p className={styles.lead}>
              ONI connects the in-seat fan experience with the tools your venue team needs to fulfill every order at scale.
              Here is how a typical game day flows from both sides.
            </p>
          </div>
          <img
            src={stockAssets.howItWorksSeat}
            alt="A fan ordering from her seat on the ONI app during a match at Mercedes-Benz Stadium"
            className={styles.heroImage}
            loading="eager"
          />
        </div>
      </section>

      <section className={`section ${styles.framing}`}>
        <div className={`container ${styles.framingGrid}`}>
          <article className={styles.framingCard}>
            <span className="sectionLabel">Fan side</span>
            <h2 className={styles.framingTitle}>Scan, Order, Track</h2>
            <p>
              Fans scan a QR code, verify with a one-time code, browse concessions, and order to their seat — all without
              leaving their row or downloading an app.
            </p>
          </article>
          <article className={styles.framingCard}>
            <span className="sectionLabel">Operator side</span>
            <h2 className={styles.framingTitle}>Route, Fulfill, Measure</h2>
            <p>
              Your venue team receives routed orders, manages vendor queues, dispatches runners, and tracks performance
              in real time from one dashboard.
            </p>
          </article>
        </div>
      </section>

      <section className={`section ${styles.steps}`}>
        <div className="container">
          <ol className={styles.stepList}>
            {howItWorksSteps.map((step, index) => (
              <li
                key={step.number}
                className={`${styles.stepBlock} ${index % 2 === 1 ? styles.stepBlockReverse : ''}`}
              >
                <div className={styles.stepNumber}>{step.number}</div>
                <div className={styles.stepContent}>
                  <span className={styles.audience}>
                    {step.audience === 'fan' ? 'Fan experience' : step.audience === 'operator' ? 'Operator tools' : 'Both sides'}
                  </span>
                  <h2 className={styles.stepTitle}>{step.title}</h2>
                  <p className={styles.stepDetails}>{step.details}</p>
                  <ul className={styles.points}>
                    {step.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <CTASection />
    </>
  );
}

export default HowItWorksPage;
